// Sportgramme - App.jsx
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import { routes } from "./routes";

// 🛡️ Standardized Providers
import { AuthProvider } from "../auth/context/AuthProvider";
import { SecurityProvider } from "../auth/registered/SEC_03_03_SecurityContext";
import { BatchProvider } from "../registered/upload/context/BatchContext";
import { TrustProvider } from "../auth/registered/SEC_07_00_TrustContext";


// 🆕 Help System & Navigation Imports
import { HelpProvider } from "../registered/common/help/HelpContext";
import GlobalHelpDrawer from "../registered/common/help/GlobalHelpDrawer";
import { NavigationProvider } from "../registered/common/navigation/NavigationContext";

export default class App extends React.Component {
  render() {
    return (
      <AuthProvider>
        <SecurityProvider>
          <TrustProvider>
            <HelpProvider>
              <BatchProvider>
                <BrowserRouter>
                  {/* 🎯 ESSENTIAL FIX: NavigationProvider must sit INSIDE BrowserRouter to use its logic */}
                  <NavigationProvider>
                    <Layout>
                      <Routes>
                        {routes.map((r) => (
                          <Route
                            key={r.path}
                            path={r.path}
                            element={<r.element />}
                          />
                        ))}
                      </Routes>
                    </Layout>

                    {/* The Drawer sits here to overlay the layout */}
                    <GlobalHelpDrawer />
                  </NavigationProvider>
                </BrowserRouter>
              </BatchProvider>
            </HelpProvider>
          </TrustProvider>
        </SecurityProvider>
      </AuthProvider>
    );
  }
}